var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgInteractionsListener',{staticClass:"svg-interactions-listener",attrs:{"svg-url":_vm.svgUrl,"svg-data":_vm.svgData,"use-unique-element-id-throughout-project":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }